export default __webpack_public_path__ + "static/media/bgPoster.8c19b644.jpg";